/**
 * Formatta un numero di crediti ECM: intero se tondo, altrimenti con
 * i decimali (virgola come separatore, stile italiano).
 * Es: 2 → "2", 2.4 → "2,4", 1.50 → "1,5".
 */
export function formatCredits(val) {
    if (val == null || val === '') return '0';
    const n = parseFloat(val);
    if (Number.isNaN(n)) return '0';
    if (Number.isInteger(n)) return String(n);
    // max 2 decimali, senza zeri finali, virgola come separatore
    return n.toFixed(2).replace(/0+$/, '').replace(/\.$/, '').replace('.', ',');
}
